import { FC, PropsWithChildren } from "react";
import { useLocation } from "react-router-dom";

import getBackTo from "web/utils/system/url/getBackTo";
import ErrorBoundary from "web/Layout/ErrorBoundary";
import SearchAutocomplete from "web/Layout/SearchAutocomplete";

import { Classes } from "web/types/Common";

import classify from "web/classify";

import BackNavElement from "../BackNavElement";
import defaultClasses from "./headerSearch.scss";

interface IHeaderSearch {
  classes?: Classes;
  to?: string;
  back?: boolean;
  backCb?: () => void;
}

const HeaderSearch: FC<PropsWithChildren<IHeaderSearch>> = ({
  classes = {},
  to = "",
  back = false,
  children,
  backCb,
}) => {
  const { search } = useLocation();
  return (
    <div className={classes.root}>
      <BackNavElement to={getBackTo(to, search)} back={back} backCb={backCb} />
      <div className={classes.search}>
        <ErrorBoundary smallTextSize>
          <SearchAutocomplete
            className={classes.searchAutocomplete}
            variant="header"
          />
        </ErrorBoundary>
      </div>
      {children}
    </div>
  );
};

export default classify<PropsWithChildren<IHeaderSearch>>(defaultClasses)(
  HeaderSearch
);
